<template>
    <div class="Perfil">
        <Menu :sesion="sesion" :url="url" v-if="sesion"/>
        <Submenu :menuActivo="1" :url="url"/>

        <div class="body">
            <div class="container-fluid pt-3">
                <div class="row">
                    
                    <!--Card Perfil-->
                    <div class="col-sm-3 mt-2">
                        <div class="card row text-center card-perfil" style="max-width: 18rem;">
                            <img class="card-img-top img-fluid mt-1" :src="fotoUser" alt="Card image">
                            <p class="card-text col-md-12 mt-3">{{datos.user}}</p>
                            <hr>
                            <div class="card-body mx-0 my-0 py-0 text-center wrapper">
                                
                                <h4 class="card-title col-md-12">{{datos.nombre}} {{datos.apellidos}}</h4>
                                <div class="membresia" v-if="rol == '0'">
                                    Membresia
                                    <router-link to="/pagos"><p class="card-text col-md-12" v-if="datos.t_user == '0'">Gratis</p></router-link>
                                    <router-link to="/pagos"><p class="card-text col-md-12" v-if="datos.t_user == '1'">Mensual</p></router-link>
                                    <router-link to="/pagos"><p class="card-text col-md-12" v-if="datos.t_user == '2'">Semestral</p></router-link>
                                    <router-link to="/pagos"><p class="card-text col-md-12" v-if="datos.t_user == '3'">Anual</p></router-link>
                                </div>
                                <div class="membresia" v-else>
                                    <a href="#"><p class="card-text col-md-12">Membresia Empresarial</p></a>
                                </div>
                                
                                <p class="fecha_fin mt-2" v-if="datos.t_user != '0'">Vence <b>{{fecha_fin}}</b></p>
                                <p class="text-center mt-2"><star-rating class="col-md-12" :read-only="true" :increment="0.01" :show-rating="false" :star-size="18" v-model="rating"></star-rating></p> 
                                <button v-if="fotoEditable == true" class="btn btn-success btn-foto my-3" data-toggle="modal" data-target="#staticBackdrop">
                                    Subir Foto
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-sm-9 mt-2">
                        
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#datos" role="tab">Datos</a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#direccion" role="tab">Dirección</a>
                            </li>
                            <li class="nav-item" role="presentation" v-show="rol === '0'">
                                <a class="nav-link" id="contact-tab" data-toggle="tab" href="#conocimientos" role="tab">Conocimientos</a>
                            </li>
                            <li class="nav-item" role="presentation" v-show="rol === '0'">
                                <a class="nav-link" id="sobre-tab" data-toggle="tab" href="#sobremi" role="tab">Sobre mi</a>
                            </li>
                        </ul>

                        <!--Spinner-->
                        <div class="d-flex justify-content-center mt-5" v-if="!status">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>

                        <form @submit="validar" v-else> 
                            <div class="tab-content" id="myTabContent">
                                <!--Seccion Datos-->
                                <div class="tab-pane fade show active" id="datos" role="tabpanel" aria-labelledby="home-tab">
                                    <div class="container-fluid">
                                        <div class="row">
                                            <div class="col-sm-6 pt-3">
                                                <div class="form-group">
                                                    <label for="apellido" class="badge badge-dark">Apellidos</label>
                                                    <input type="text" class="form-control" v-model="datos.apellidos" :disabled="editable">
                                                </div>
                                                <div class="form-group">
                                                    <label for="apellido" class="badge badge-dark">Email Principal</label>
                                                    <input type="email" class="form-control" min="10" v-model="datos.email1" disabled>
                                                </div>
                                                <div class="form-group" v-if="rol==1">
                                                    <label for="apellido" class="badge badge-dark">Empresa</label>
                                                    <input type="text" class="form-control" min="10" v-model="datos.empresa" :disabled="editable">
                                                </div>
                                                <div class="form-group" v-if="rol==1">
                                                    <label for="apellido" class="badge badge-dark">Industria</label>
                                                    <select class="form-control" v-model="datos.industria" :disabled="editable">
                                                        <option :value="f.nombre_esp" v-for="f in industria" :key="f.id_industria">
                                                            {{f.nombre_esp}}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label for="apellido" class="badge badge-dark">Alias de Usuario</label>
                                                    <input type="text" class="form-control" v-model="datos.user" disabled>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 pt-3">
                                                <div class="form-group">
                                                    <label for="apellido" class="badge badge-dark">Nombres</label>
                                                    <input type="text" class="form-control" v-model="datos.nombre" :disabled="editable">
                                                </div>
                                                <div class="form-group">
                                                    <label for="apellido" class="badge badge-dark">Email Secundario</label>
                                                    <input type="email" class="form-control" v-model="datos.email2" :disabled="editable">
                                                </div>
                                                <div class="form-group" v-if="rol==1">
                                                    <label for="puesto" class="badge badge-dark">Puesto</label>
                                                    <input type="text" class="form-control" v-model="datos.puesto" :disabled="editable">
                                                </div>
                                                <div class="form-group">
                                                    <label for="taxid" class="badge badge-dark">TAX ID</label>
                                                    <input type="text" class="form-control" v-model="datos.tax_id" :disabled="editable">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <!--Seccion Direccion-->
                                <div class="tab-pane fade" id="direccion" role="tabpanel" aria-labelledby="profile-tab">
                                    <div class="container-fluid">
                                        
                                        <div class="row">
                                            <div class="col-sm-12 pt-3">
                                                <div class="form-group">
                                                    <label for="apellido" class="badge badge-dark">Dirección</label>
                                                    <input type="text" class="form-control" v-model="datos.address" :disabled="editable">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-3 pt-3">
                                                <div class="form-group">
                                                    <label for="ciudad" class="badge badge-dark">Ciudad</label>
                                                    <input type="text" class="form-control" v-model="datos.ciudad" :disabled="editable">
                                                </div>
                                            </div>
                                            <div class="col-sm-3 pt-3">
                                                <div class="form-group">
                                                    <label for="estado" class="badge badge-dark">Estado</label>
                                                    <input type="text" class="form-control" v-model="datos.estado" :disabled="editable">
                                                </div>
                                            </div>
                                            <div class="col-sm-3 pt-3">
                                                <div class="form-group">
                                                    <label for="codigopostal" class="badge badge-dark">Codigo Postal</label>
                                                    <input type="number" class="form-control" v-model="datos.cp" :disabled="editable">
                                                </div>
                                            </div>
                                            <div class="col-sm-3 pt-3">
                                                <div class="form-group">
                                                    <label for="apellido" class="badge badge-dark">Pais/Región</label>
                                                    <select class="form-control" v-model="datos.pais" :disabled="editable" @change="getLada($event)">
                                                        <option :value="f.CodigoISO" v-for="f in paises" :key="f.id" :data-codigo-tel="f.CodigoTel">
                                                            {{f.Nombre}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="row">
                                            <div class="col-sm-3 pt-3">
                                                <div class="form-group">
                                                    <label for="apellido" class="badge badge-dark">Telefono</label>
                                                    <div class="row">
                                                        <div class="col-4">
                                                            <input class="form-control" maxlength="4" value="" v-model="datos.telefono_lada" :disabled="editable">
                                                        </div>
                                                        <div class="col-8">
                                                            <input type="number" class="form-control" value="" v-model="datos.telefono" :disabled="editable">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-sm-3 pt-3">
                                                <div class="form-group">
                                                    <label for="apellido" class="badge badge-dark">Móvil</label>
                                                    <div class="row">
                                                        <div class="col-4">
                                                            <input class="form-control" maxlength="4" value="" v-model="datos.celular_lada" :disabled="editable">
                                                        </div>
                                                        <div class="col-8">
                                                            <input type="number" class="form-control" value="" v-model="datos.celular" :disabled="editable">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-sm-3 pt-3">
                                                <div class="form-group">
                                                    <label for="apellido" class="badge badge-dark">Pagina Web</label>
                                                    <input type="text" class="form-control" value="" v-model="datos.pagina_web">
                                                </div>
                                            </div>

                                            <div class="col-sm-3 pt-3">
                                                <div class="form-group">
                                                    <label for="apellido" class="badge badge-dark">Linkedin</label>
                                                    <input type="text" class="form-control" value="" v-model="datos.Linkedin">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <!--Seccion de Conocimientos-->
                                <div class="tab-pane fade" id="conocimientos" role="tabpanel" aria-labelledby="contact-tab">
                                    <div class="container-fluid" >

                                        <div class="row">
                                            <div class="col-sm-6 pt-3">
                                                <div class="form-group">
                                                    <label for="producto" class="badge badge-dark">Producto</label>
                                                    <select id="" class="form-control" v-model="datos.product" :disabled="editable">
                                                        <option value="">Seleccione un Producto</option>
                                                        <option :value="f.nombre_producto" v-for="f in products" :key="f.id">{{f.nombre_producto}} </option>
                                                    </select>
                                                </div>             
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-4 pt-3" v-if="datos.t_user >= '0' && datos.t_user <= '3'">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <div class="form-group">
                                                            <label for="apellido" class="badge badge-dark">Especializacíon 1</label>
                                                            <select id="esp1" class="form-control" v-model="datos.especializacion1" :disabled="editable">
                                                                <option value="">Seleccione una Especializacíon</option>
                                                                <option :value="f.id_modulo" v-for="f in modulos" :key="f.id_modulos">{{f.module_cod}} - {{f.module_name}} </option>
                                                            </select>
                                                        </div>

                                                        <div class="form-group">
                                                            <label for="apellido" class="badge badge-dark">Nivel</label>
                                                            <select id="" class="form-control" v-model="datos.nivel1" :disabled="editable">
                                                                <option value="0">Seleccione un Nivel</option>
                                                                <option value="1">Junior</option>
                                                                <option value="2">Middle</option>
                                                                <option value="3">Senior</option>
                                                            </select>
                                                        </div>

                                                        <div class="form-group">
                                                            <label for="apellido" class="badge badge-dark" >ID Certificacion</label>
                                                            <!--<font-icon icon="question-circle" data-toggle="tooltip" data-placement="top" title="Texto con la explicacion del campo."/>-->
                                                            <button type="button" class="btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1" data-toggle="tooltip" data-placement="right" :title="tooltip">
                                                                ?
                                                            </button>
                                                        <input type="text" class="form-control" value="0" v-model="datos.certificacion1">
                                                        </div>
                                                    </div>
                                                </div>                 
                                            </div>

                                            <div class="col-sm-4 pt-3" v-if="datos.t_user >= '0' && datos.t_user <= '3'">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <div class="form-group">
                                                            <label for="apellido" class="badge badge-dark">Especializacíon 2</label>
                                                            <select id="" class="form-control" v-model="datos.especializacion2" :disabled="editable">
                                                                <option value="0">Seleccione una Especialización</option>
                                                                <option :value="f.id_modulo" v-for="f in modulos" :key="f.id_modulos">{{f.module_cod}} - {{f.module_name}}</option>
                                                            </select>
                                                        </div>

                                                        <div class="form-group">
                                                            <label for="apellido" class="badge badge-dark">Nivel</label>
                                                            <select id="" class="form-control" v-model="datos.nivel2" :disabled="editable">
                                                                <option value="0">Seleccione un Nivel</option>
                                                                <option value="1">Junior</option>
                                                                <option value="2">Middle</option>
                                                                <option value="3">Senior</option>
                                                            </select>
                                                        </div>

                                                        <div class="form-group">
                                                            <label for="apellido" class="badge badge-dark">ID Certificacion</label>
                                                            <button type="button" class="btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1" data-toggle="tooltip" data-placement="right" :title="tooltip">
                                                                ?
                                                            </button>
                                                            <input type="text" class="form-control" value="0" v-model="datos.certificacion2">
                                                        </div>
                                                    </div>
                                                </div>                 
                                            </div>

                                            <div class="col-sm-4 pt-3" v-if="datos.t_user >= '0' && datos.t_user <= '3'">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <div class="form-group">
                                                            <label for="apellido" class="badge badge-dark">Especializacíon 3</label>
                                                            <select id="" class="form-control" v-model="datos.especializacion3" :disabled="editable">
                                                                <option value="0">Seleccione una Especializacíon</option>
                                                                <option :value="f.id_modulo" v-for="f in modulos" :key="f.id_modulos">{{f.module_cod}} - {{f.module_name}}</option>
                                                            </select>
                                                        </div>

                                                        <div class="form-group">
                                                            <label for="apellido" class="badge badge-dark">Nivel</label>
                                                            <select id="" class="form-control" v-model="datos.nivel3" :disabled="editable">
                                                                <option value="0">Seleccione un Nivel</option>
                                                                <option value="1">Junior</option>
                                                                <option value="2">Middle</option>
                                                                <option value="3">Senior</option>
                                                            </select>
                                                        </div>

                                                        <div class="form-group">
                                                            <label for="apellido" class="badge badge-dark">ID Certificacion</label>
                                                            <button type="button" class="btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1" data-toggle="tooltip" data-placement="right" :title="tooltip">
                                                                ?
                                                            </button>
                                                            <input type="text" class="form-control" value="0" v-model="datos.certificacion3">
                                                        </div>
                                                    </div>
                                                </div>                 
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <!--Seccion de Sobre Mi-->
                                <div class="tab-pane fade" id="sobremi" role="tabpanel" aria-labelledby="sobre-tab">
                                    <div class="container-fluid" >
                                        <div class="row">
                                            <div class="col-sm-12 pt-3">
                                                <div class="form-group">
                                                    <label for="apellido" class="badge badge-dark">Sobre Mi</label>
                                                    <textarea class="form-control" maxlength="300" rows="5" v-model="datos.text_sobre" :disabled="editable" />
                                                </div>                 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <!--boton actualizar-->
                                <div class="wrapper">
                                    <button type="submit" v-if="editable == false" class="fadeIn fourth Actualizar orange mt-4">Finalizar Registro</button>
                                </div>
                            </div>

                            <div class="row" v-if="editable == true">
                                <div class="col-sm-8"></div>
                                <div class="col-sm-4">
                                    <p class="text-center">¿Necesitas actualizar tus datos? <br> Contáctanos</p>
                                    <p class="text-center">
                                        <button type="button" class="btn btn-danger btn-sm" data-toggle="modal" data-target="#helpdeskModal">
                                            <font-icon icon="user"></font-icon> <br> Help Desk
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </form>
                        
                    </div>

                    <!--Modal Editar Foto-->
                    <div class="modal fade" id="staticBackdrop" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="staticBackdropLabel">Seleccione Una Foto</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div>
                                    <input type="file" class="form-control" @change="addFile">
                                    <hr>
                                    <div class="wrapper my-0 mx-0 px-0 py-0">
                                        <button type="submit" class="btn btn-success" data-dismiss="modal" @click="subirImage">Subir</button>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>

                    <!--Modal Help Desk-->
                    <div class="modal fade" id="helpdeskModal" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                 <div class="modal-header orange">
                                    <span>Indicanos qué datos quieres actualizar</span>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <p style="text-align: justify">Envíanos el <b>Email Principal</b> y el <b>Alias de Usuario</b> con los que te registraste, 
                                    indicándonos que datos son los que quieres actualizar, a la siguiente dirección de correo:</p>
                                    
                                    <p class="text-center">
                                        <a class="text-center" href="mailto:data_update@itsapp.com.mx">data_update@itsapp.com.mx</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import { globalFunctions } from '@/hooks/globalFunctions'
import { mapState } from 'vuex'

import StarRating from 'vue-star-rating';
import Submenu from '@/components/Submenu';
import Menu from '@/components/Menu';

import $ from 'jquery'

export default {
    name: 'Perfil',
    mixins: [ globalFunctions ],
    components:{ Submenu, StarRating, Menu },
    data () {
        return {
            rol: '',
            datos_perfil: [],
            check_taxID: false,
            modulos: [],
            sesion: false,
            rating: 2,
            disabled1: 0,
            disabled2: 0,
            disabled3: 0,
            products: [],
            fecha_fin: '',
            datos: { 
                apellidos: '',
                email1: '',
                user: '',
                nombre: '',
                email2: '',
                tax_id: '',
                empresa: '',
                puesto: '',
                industria: {},
                address: '',
                ciudad: '',
                estado: '',
                cp: '',
                pais: '',
                telefono: '',
                telefono_lada: '',
                celular: '',
                celular_lada: '',
                product:[],
                pagina_web: '',
                Linkedin: '',
                especializacion1: '',
                nivel1: '',
                certificacion1: '',
                especializacion2: '',
                nivel2: '',
                certificacion2: '',
                especializacion3: '',
                nivel3: '',
                certificacion3: '',
                text_sobre: ''},
            fotoUser: '',
            msg: '',
            selectedFile: '',
            fileName: '',
            t_user: '',
            status: false,
            UserName: localStorage.userID,
            band_alert: false,
            editable: '',
            fotoEditable: false,
            tooltip: '¿Cuentas con un "SAP Open Digital Badge" de esta especialización? Proporcionanos el link.',
            paises: []
        }   
    },
    mounted() {
        this.rol =  localStorage.rol;

        let resp = this.checkUser();
        this.sesion = resp;

        this.getDatosPerfil();
        this.getModulos();
        
        $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {            
            $('[data-toggle="tooltip"]').tooltip();
        });
        
  },
  computed:{
    ...mapState(['url','urlFoto'])
  },
  methods: {
    getLada(event){
        const codigoTelSeleccionado = event.target.selectedOptions[0].getAttribute('data-codigo-tel');
        this.datos.telefono_lada = codigoTelSeleccionado;
        this.datos.celular_lada = codigoTelSeleccionado;
    },
    getDatosPerfil(){

        //Get Industrias
        this.axios.post(this.url + 'consultasBasicas.php', { flag: 9 }).then((responce) =>{
            this.industria = responce.data;
        });
        
        //Get Paises
        this.axios.post(this.url + 'consultasBasicas.php', { flag: 10 }).then((responce) =>{
            this.paises = responce.data;
        });
        
        this.msgerror = false;
    
        let data = {
            rol: this.rol,
            id: this.UserName
        }
        
        //obtenemos los datos del usuario ya sea empresa o consultor
        this.axios.post(this.url + 'consultar.php', data).then((responce) =>{
            //guardo los datos que tienen en comun el consultor y empresa
            
            if(responce.data[0].editable == '01'){
                this.editable = false;
                this.fotoEditable = false;
            } 
            else if (responce.data[0].editable == '11')
            {
                this.editable = true;
                this.fotoEditable = false;
            }
            else {
                this.editable = false;
                this.fotoEditable = true;
            }
            
            this.datos_perfil = responce.data;
            this.datos.nombre = this.datos_perfil[0].nombres;  
            this.datos.apellidos = this.datos_perfil[0].apellidos;
            this.datos.empresa = this.datos_perfil[0].empresa;
            this.datos.puesto = this.datos_perfil[0].puesto;
            this.datos.industria = this.datos_perfil[0].industria;
            this.datos.user = this.datos_perfil[0].usuario;
            this.datos.email1 = this.datos_perfil[0].email_princ;
            this.datos.email2 = this.datos_perfil[0].email_sec;
            this.datos.telefono = this.datos_perfil[0].telefono;
            this.datos.telefono_lada = this.datos_perfil[0].telefono_lada;
            this.datos.celular = this.datos_perfil[0].celular;
            this.datos.celular_lada = this.datos_perfil[0].celular_lada;
            this.datos.address = this.datos_perfil[0].direccion;
            this.datos.ciudad = this.datos_perfil[0].ciudad;
            this.datos.estado = this.datos_perfil[0].estado_provincia;
            this.datos.cp = this.datos_perfil[0].CP;
            this.datos.pais = this.datos_perfil[0].pais_region;
            this.datos.pagina_web = this.datos_perfil[0].pagina_web;
            this.datos.Linkedin = this.datos_perfil[0].linkedin;              
            this.datos.text_sobre = this.datos_perfil[0].notas;
            this.datos.product = this.datos_perfil[0].producto;
            this.datos.tax_id = this.datos_perfil[0].tax_id;
            this.datos.especializacion1 =  this.datos_perfil[0].especializacion1;
            this.datos.nivel1 =  this.datos_perfil[0].nivel_conocimiento1;
            this.datos.certificacion1 =  this.datos_perfil[0].certificacion1;
            this.datos.especializacion2 =  this.datos_perfil[0].especializacion2;
            this.datos.nivel2 =  this.datos_perfil[0].nivel_conocimiento2;
            this.datos.certificacion2 =  this.datos_perfil[0].certificacion2;
            this.datos.especializacion3 =  this.datos_perfil[0].especializacion3;
            this.datos.nivel3 =  this.datos_perfil[0].nivel_conocimiento3;
            this.datos.certificacion3 =  this.datos_perfil[0].certificacion3;
            this.datos.t_user =  this.datos_perfil[0].t_user;
            this.fecha_fin = this.datos_perfil[0].fecha_fin;
            this.rating = parseFloat(this.datos_perfil[0].estrellas);

            if(localStorage.rol == 0 && (this.datos.t_user == 3 || this.datos.t_user == 0 || this.datos.t_user == 2 || this.datos.t_user == 1) && 
            (this.datos.especializacion1 > 0 || this.datos.especializacion2 > 0 || this.datos.especializacion3 > 0)){
                this.band_alert = true;
            }

            if(this.datos_perfil[0].avatar != ''){
                this.fotoUser = this.getUrl(this.datos_perfil[0].avatar);
            }else{
                this.fotoUser = this.urlFoto;                
            }

            if(this.datos.tax_id != "" && this.datos.tax_id != null){
                this.check_taxID = true;
            }

            this.checkEspD();
            this.status = responce.status;
        })
    },

    checkEspD(){
        if(this.datos.especializacion1 != '0'){
            this.disabled1 = 1;
        }
        if(this.datos.especializacion2!= '0'){
            this.disabled2 = 1;
        }
        if(this.datos.especializacion3 != '0'){
            this.disabled3 = 1;
        }
    },

    getModulos(){
        let data = {
            flag: 0
        }
        
        //obtenemos los datos del usuario ya sea empresa o consultor
        this.axios.post(this.url + 'consulta_mod.php', data).then((responce) =>{
            this.modulos = responce.data;
        });
        
        //Obtener Producto
        this.axios.post(this.url + 'consulta_prod.php', data).then((responce) =>{
            this.products = responce.data;
        });
    },

    validar(e){
        e.preventDefault();
        
        if(this.datos.nombre.length <= 0){
            this.msjError("Campo Nombre es obligatorio")
            return
        }else if(this.datos.apellidos.length <= 0){
            this.msjError("Campo Apellidos es obligatorio")
            return
        }else if(this.datos.user.length <= 0) {
            this.msjError("Campo Nombre de Usuario es obligatorio")
            return
        }else if(this.datos.email1.length <= 0) {
            this.msjError("Campo Email Principal es obligatorio")
            return
        } else if(this.datos.address.length <= 0) {
            this.msjError("Campo Dirección obligatorio")
            return
        } else if(this.datos.telefono.length <= 0) {
            this.msjError("Campo Telefono es obligatorio")
            return
        } else if(this.datos.telefono_lada == null || this.datos.telefono_lada == '') {
            this.msjError("Campo Lada Telefono es obligatorio")
            return    
        } else if(this.datos.celular.length <= 0) {
            this.msjError("Campo Móvil es obligatorio")
            return
        } else if(this.datos.celular_lada == null || this.datos.celular_lada == '') {
            this.msjError("Campo Lada Móvil es obligatorio")
            return
        } else if(this.datos.ciudad.length <= 0) {
            this.msjError("Campo Ciudad es obligatorio")
            return
        } else if(this.datos.estado.length <= 0) {
            this.msjError("Campo Estado es obligatorio")
            return
        } else if(this.datos.cp.length <= 0) {
            this.msjError("Campo Codigo Postal es obligatorio")
            return
        } else if(this.datos.pais.length <= 0) {
            this.msjError("Campo Pais es obligatorio")
            return
        }
        else if(this.datos.email2.length <= 0) {
            this.msjError("Campo Email Secundario es obligatorio")
            return
        }

        if (this.rol != 1){
            if(this.datos.especializacion1 <= 0) {
                this.msjError("Especialización 1 es obligatorio")
                return
            } else if(this.datos.nivel1 <= 0) {
                this.msjError("Campo Nivel de Especialilzacíon es obligatorio")
                return
            }
        }

        this.actualizar();
    },

    actualizar(){

        this.msgerror = false;
        const UserName = localStorage.userID;
        this.msgerror = false;

            let data = {
                flag: 2,
                rol: this.rol,
                id: UserName,
                datos: this.datos
            }
            
            //mandamos los datos para actualizar
            if(this.checkEsp()){
                this.axios.post(this.url + 'alta_usuario.php', data).then((responce) =>{

                if(responce.data == '200'){
                    this.getDatosPerfil();
                    this.actualizar2();
                }

                else{
                    this.msg = responce.data;
                    this.msjError(responce.data);
                }
        
            });
            }else{
                this.msg = 'Complete los datos de su especialización';
                this.msjError('Complete los datos de su especialización');
            }
            
    },

    actualizar2(){

        if(this.band_alert == false && this.rol == '0' && this.datos.t_user == 0){
            
            this.$swal.fire({
                title: 'RECUERDA',
                text: "You won't be able to revert this!",
                icon: 'info',
                html:
                '<span> Para hacer propuestas a los proyectos publicados: </span> <br> <br>' +
                '<span>Con el plan Mensual solo te permitirá hacer propuestas a los proyectos que hagan match con tu especialización 1 </span> <br><br>' +
                '<span>Con el plan Semestral te permitirá hacer propuestas a los proyectos que hagan match con tu especialización 1 ó 2 </span> <br><br>' +
                '<span>Con el plan Anual te permitirá hacer propuestas a los proyectos que hagan match con tus 3 especializaciones.</span> <br><br>' +
                '<span>Podrás actualizar tu membresía en cualquier momento en la pestaña de “Suscripción”.</span>',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok'
                }).then((result) => {
                if (result.isConfirmed) {}
            })
        }else{
            this.msjOk();
        }
    },

    addFile(event){
        this.selectedFile = event.target.files[0];
        this.fileName = this.selectedFile.name;
    },

    subirImage(){            
                
        if(this.selectedFile != null)
        {
            const fd = new FormData();
            fd.append('file',this.selectedFile, this.selectedFile.name);
            
            this.axios.post(this.url + 'uploadImagen.php', fd, {
                header:{
                    'Content-Type': 'multipart/form-data'
            }
            
            }).then((responce) =>{
                if(responce.data.res == '200'){
                    
                    let data = {
                        id: localStorage.userID,
                        fileName: responce.data.nombre,

                    }

                    this.axios.post(this.url + 'altaImages.php', data).then((responce) =>{
                        if(responce.data == '200'){
                            //modal hide
                            this.msjOk();
                            this.getDatosPerfil();
                        }
                    });
                    
                }else{
                    this.msjError(responce.data);
                }
            });
        }    
    },

    checkEsp(){
        if(localStorage.rol == '0'){
            if((this.datos.especializacion1 != '0' && (this.datos.nivel1 == '0' ))
                || (this.datos.nivel1 != '0' && (this.datos.especializacion1 == '0' ))){
                return false;
            }
            if((this.datos.especializacion2 != '0' && (this.datos.nivel2 == '0'))
                || (this.datos.nivel2 != '0' && (this.datos.especializacion2 == '0'))){
                return false;
            }
            if((this.datos.especializacion3 != '0' && (this.datos.nivel3 == '0'))
                || (this.datos.nivel3 != '0' && (this.datos.especializacion3 == '0'))){
                return false;
            }
        }
        
        return true;
    }
  }
}
</script>


<style scoped>
    .wrapper{
        display: flex;
        align-items: center;
        flex-direction: column; 
        justify-content: center;
        width: 100%;
        min-height: 100%;
        padding: 20px;
    }
    .Actualizar{
        background-color: #ff573b;
        border: none;
        color: white;
        padding: 8px 10px;
        border-radius: 5px;
        font-size: 15px;
        
    }
    .orange{
        background-color: #ff573b;
        color: white;
    }

    .orange:hover{
        background-color: #ff200b;
        color: white;
    }
    *:focus{
        outline: none;
    }
    div.card{
        display: block;
        margin-left: auto;
        margin-right: auto;
        
    }
    img{
        
        width: 100px;
        height: 100px;
    
    }
    .btn-foto{
        padding: 5px 8px;
        font-size: 12px;
    }
    .body{
        background-color: #fff;
    }
    .card-perfil{
        background-color: #121024;
        color: #fff;
    }
    .card-body a{
        color: rgb(50, 231, 119);
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/views/Perfil/Perfil.vue